import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from 'services/token/token-service.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public tokenService: TokenService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      await this.tokenService.handleAccessCode(params.code);
      this.router.navigate(['/']);
    });
  }
}
